import {Component, HostListener, OnInit} from '@angular/core';
import {environment} from "../environments/environment";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter, map, mergeMap} from "rxjs";
import {HideHeaderService} from "./services/hide-header.service";
import {NotificationService} from "./services/notification.service";
import {ModalService} from "./services/modal.service";
import {UserDataService} from "./pages/user-list/services/user-data.service";
import {AuthService} from "./services/auth/auth.service";
import {UserInfoService} from "./services/user-info.service";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  currentLang: string | undefined
  hideHeader: string | undefined
  isSmallMenu = false
  isOpenMobileMenu = false
  headerTitle: string | undefined

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private hideHeaderService: HideHeaderService,
    private notificationService: NotificationService,
    private modalService: ModalService,
    private authService: AuthService,
    private userInfoService: UserInfoService
  ) {
  }

  ngOnInit() {
    this.getLocalStorageAuthData()
    this.setCurrentLang()
    this.setRouteData()
  }

  setCurrentLang() {
    this.currentLang = localStorage.getItem('locale') || environment.defaultLocale
    this.translateService.use(this.currentLang)
    localStorage.setItem('locale', this.currentLang)
  }

  setRouteData(): void {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
      .subscribe((event) => {
        // Close all notification
        this.notificationService.hideNotification()

        // Set hide header
        if (event['headerHide']) {
          this.hideHeader = event['headerHide']
          this.hideHeaderService.hideHeaderService$.next(event['headerHide'])
        } else {
          this.hideHeader = event['headerHide']
          this.hideHeaderService.hideHeaderService$.next(false)
        }

        // Set title in header
        if (event['titlePage']) {
          this.headerTitle = event['titlePage']
        }

      });
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.notificationService.hideNotification()
    this.modalService.closeModal()
  }

  getLocalStorageAuthData() {
    if (this.authService.isAuthenticated()) {
      const agentId = localStorage.getItem('agent_id') || undefined
      const userId = localStorage.getItem('user_id') || undefined
      if (agentId && userId) {
        this.userInfoService.userId$.next(+userId)
        this.userInfoService.agentId$.next(agentId)
      }
    }
  }
}
